import { render } from "./MediaPage.vue?vue&type=template&id=30e99446"
import script from "./MediaPage.vue?vue&type=script&lang=js"
export * from "./MediaPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AlterLau\\walter-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__